<div class="route-component">
    <div class="search-component">
        <h4>
            Client Areas
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['Client', 'Create']" (click)="addClientAreas()">
                        Add <i class="fas fa-plus"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="getClientAreasByClientId(paging)">
                    <button class="search-button" (click)="getClientAreasByClientId(paging)">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="clientAreas"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getClientAreasByClientId($event)"
            [showEdit]="showEdit || false"
            (editItem)="editClientArea($event)"
            [showDelete]="showDelete || false"
            (deleteItem)="deleteClientArea($event)">
        </pageable-table>
    </div>
</div>